import * as _ from 'lodash';

const nullifyValue = (value: any) => {
  return !_.isString(value) || (_.isString(value) && value.length)
    ? value
    : null;
}

const nullifyObject = (object: any): any => {
  return Object.keys(object).reduce((acc, key) => {
    acc[key] = nullifyEntity(object[key]);

    return acc;
  }, {});
}

const nullifyArray = (array: any[]): any[] => {
  return array.map(nullifyEntity);
}

const nullifyEntity = (entity: any): any => {
  if (_.isString(entity) || _.isNumber(entity)) {
    return nullifyValue(entity);
  }

  if (_.isArray(entity)) {
    return nullifyArray(entity);
  }

  if (_.isObject(entity)) {
    return nullifyObject(entity);
  }

  return entity;
}

const stringifyValue = (value: any): any => {
  return _.isNull(value) ? '' : value;
}

const stringifyArray = (array: any[]): any[] => {
  return array.map(stringifyEntity);
}

const stringifyObject = (object: any): any => {
  return Object.keys(object).reduce((acc, key) => {
    acc[key] = stringifyEntity(object[key]);

    return acc;
  }, {});
}

const stringifyEntity = (entity: any) => {
  if (_.isArray(entity)) {
    return stringifyArray(entity);
  }

  if (_.isObject(entity)) {
    return stringifyObject(entity);
  }

  return stringifyValue(entity);
}

export function replaceEmptyStringWithNull(body: any): any {
  // parche para no mandar string vacios al back
  // si esta vacio = null
  return Object.keys(body).reduce((acc, key) => {
    acc[key] = nullifyEntity(body[key]);

    return acc;
  }, {});
}

export function replaceNullWithEmptyString(data: any): any {
  return Object.keys(data).reduce((acc, key) => {
    acc[key] = stringifyEntity(data[key]);

    return acc;
  }, {});
}



// WEBPACK FOOTER //
// ./src/util.ts